export const editorConfig = {
    versionCheck: false,
    toolbar: [
        ['Styles', 'Format', 'Undo', 'Redo', 'Cut', 'Copy', 'Paste', 'Find', 'Replace', 'SelectAll', 'RemoveFormat'],
        ['Bold', 'Italic', 'Underline', 'Strike', 'NumberedList', 'BulletedList', 'EmojiPanel'],
        ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
        ['Link', 'Unlink', 'Image', 'Table', 'Maximize']
    ],
    extraPlugins: ['emoji'],
    emoji_followingSpace: true
    //     items: [
    //         "heading",
    //         "|",
    //         "Alignment",
    //         "fontFamily",
    //         "FontSize",
    //         "|",
    //         "FontColor",
    //         "fontBackgroundColor",
    //         "highlight",
    //         "|",
    //         "Bold",
    //         "Italic",
    //         "Underline",
    //         "Strikethrough",
    //         "blockQuote",
    //         'bulletedList',
    //         'numberedList',
    //         "|",
    //         "indent",
    //         "outdent",
    //         "|",
    //         "Link",
    //         "linkImage",
    //         "insertTable",
    //         "mediaEmbed",
    //         "HorizontalLine",
    //         "RemoveFormat",
    //         "selectAll",
    //         "specialCharacters",
    //         "imageResize",
    //         "|",
    //         'undo',
    //         'redo',
    //         'Image'
    //     ],
    // },
    // mediaEmbed: {
    //     previewsInData: true,
    //     removeProviders: ['instagram', 'twitter', 'googleMaps', 'flickr', 'facebook']
    // }
}

